import React, { useState, useEffect } from "react";
import io from "socket.io-client";

import Create from "../components/Online/Create";
import Join from "../components/Online/Join";
import OnlineGame from "../components/Online/OnlineGame";

// const socket = io("http://localhost:3001");
const socket = io('https://game-rival.glitch.me');

const Online = () => {
  const [activeTab, setActiveTab] = useState("tab1");
  const [inRoom, setInRoom] = useState(false);

  const [name, setName] = useState("");
  const [roomId, setRoomId] = useState("");
  const [friend, setFriend] = useState("");
  const [players, setPlayers] = useState([]);

  const [gridSize, setGridSize] = useState(0);

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      {!inRoom ? (
        <div className=" w-80 h-80 flex flex-col rounded-md">
          <div className="font-semibold text-lg flex justify-around items-center w-full ">
            <button
              className={`flex-1 p-2 rounded-tl-md ${
                activeTab === "tab1" ? "bg-theme-5 text-slate-100" : "bg-theme-4 shadow-[inset_0_-1px_3px_rgba(0,0,0,0.6)]"
              }`}
              onClick={() => setActiveTab("tab1")}
            >
              Create
            </button>
            <button
              className={`flex-1 p-2 rounded-tr-md ${
                activeTab === "tab2" ? "bg-theme-5 text-slate-100" : "bg-theme-4 shadow-[inset_0_-1px_3px_rgba(0,0,0,0.6)]"
              }`}
              onClick={() => setActiveTab("tab2")}
            >
              Join
            </button>
          </div>
          <div className="flex-1 p-4 h-full bg-theme-5">
            {activeTab === "tab1" && (
              <Create
                socket={socket}
                setInRoom={setInRoom}
                name={name}
                setName={setName}
                roomId={roomId}
                setRoomId={setRoomId}
                setGridSize={setGridSize}
                gridSize={gridSize}
              />
            )}
            {activeTab === "tab2" && (
              <Join
                socket={socket}
                setInRoom={setInRoom}
                name={name}
                setName={setName}
                roomId={roomId}
                setRoomId={setRoomId}
                setFriend={setFriend}
                setPlayers={setPlayers}
                setGridSize={setGridSize}
              />
            )}
          </div>
        </div>
      ) : (
        <OnlineGame
          socket={socket}
          gridSize={gridSize}
          name={name}
          roomId={roomId}
          friend={friend}
          setFriend={setFriend}
          players={players}
          setPlayers={setPlayers}
        />
      )}
    </div>
  );
};

export default Online;
